import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
@Component({
  selector: 'app-mockups',
  templateUrl: './mockups.component.html',
  styleUrls: ['./mockups.component.css']
})
export class MockupsComponent {
  categories = [
    {
      name: 'Employee',
      items: [
        'Employee Dashboard',
        'Employee Career Path',
        'Employee All Programmes Requests',
        'Employee Pending Programmes Request'
      ]
    },
    {
      name: 'Program',
      items: [
        'Program',
        'Search Programs'
      ]
    },
    {
      name: 'Manager',
      items: [
        'Manager team Requests Pending'
      ]
    },
    {
      name: 'Proposal',
      items: [
        'Proposal Repository Dashboard',
        'Proposal Repository'
      ]
    }
  ];
  constructor(private router: Router) {

  }
  openEmployee(data: string) {
    const navigationExtras: NavigationExtras = {
      state: {
        employeeData: data
      }
    };
    this.router.navigate(['Home/employee', { employeeData: data }]);
  }
}
